const INITIAL_STATE = {
    relationshipcalled : 0
}
const relationshipcalled = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADD':
            return {
                ...state,
                relationshipcalled: action.payload,
            }
        default:
            return state;
    }
}

export default  relationshipcalled;
